import React from 'react';
import PublicStaticPage from './PublicStaticPage';

const TermsOfService = () => <PublicStaticPage pageKey="terms" />;

export default TermsOfService;
